const currentYear = new Date().getUTCFullYear();

/**
 * Array of selectable years.
 */
export const SELECTABLE_YEARS: number[] = [];

for (let year = 2012; year <= currentYear + 1; year++) {
  SELECTABLE_YEARS.push(year);
}
